import styled from 'styled-components';

export const Container = styled.span<{
  bgColor: string;
  fontColor: string;
}>`
  svg,
  img {
    display: block;
    width: 40px;
    height: 40px;
    ${({ bgColor }) => bgColor && `background-color: ${bgColor};`}
    border-radius: ${({ theme }) =>
      theme.configs.trackingDetailsBox.borderRadius === 'round'
        ? '20px'
        : '0px'};
  }
  path {
    ${({ fontColor }) => fontColor && `fill: ${fontColor};`}
  }
  polygon {
    ${({ fontColor }) => fontColor && `fill: ${fontColor};`}
  }
  div {
    width: 40px;
    height: 40px;
  }
`;
